import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getUnitMeasurementList as getUnitMeasurementListApi,
	getUnitMeasurement as getUnitMeasurementApi,
    getUnitMeasurementByCode as getUnitMeasurementByCodeApi,
	addNewUnitMeasurement as addNewUnitMeasurementApi,
	updateUnitMeasurement as updateUnitMeasurementApi,
	deleteUnitMeasurement as deleteUnitMeasurementApi,
} from '../../helpers/residue/backend_helper';

export const getUnitMeasurementList = createAsyncThunk('unitMeasurements/getUnitMeasurementList', async () => {
	try {
		const response = getUnitMeasurementListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getUnitMeasurement = createAsyncThunk('unitMeasurements/getUnitMeasurement', async unitMeasurement_id => {
	try {
		const response = getUnitMeasurementApi(unitMeasurement_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getUnitMeasurementByCode = createAsyncThunk('unitMeasurements/getUnitMeasurementByCode', async code => {
	try {
		const response = getUnitMeasurementByCodeApi(code);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewUnitMeasurement = createAsyncThunk('unitMeasurements/addNewUnitMeasurement', async unitMeasurement => {
	try {
		const response = addNewUnitMeasurementApi(unitMeasurement);
		toast.success('UnitMeasurement agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar unitMeasurement.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateUnitMeasurement = createAsyncThunk('unitMeasurements/updateUnitMeasurement', async (unitMeasurement) => {
		try {
			const response = updateUnitMeasurementApi(unitMeasurement);
			toast.success('UnitMeasurement actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar unitMeasurement.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteUnitMeasurement = createAsyncThunk('unitMeasurements/deleteUnitMeasurement', async unitMeasurement => {
	try {
		const response = await deleteUnitMeasurementApi(unitMeasurement);
		toast.success('UnitMeasurement eliminado exitosamente.', { autoClose: 3000 });
		return { unitMeasurement, ...response };
	} catch (error) {
		toast.error('Error al eliminar unitMeasurement.', { autoClose: 3000 });
		throw new Error(error);
	}
});
